import { createContext, useContext, useState } from "react";

const ToastContext = createContext();
const LoaderContext = createContext();

export const useToastContext = () => useContext(ToastContext);
export const useLoaderContext = () => useContext(LoaderContext);

export const ToastProvider = ({ children }) => {
  const [toastState, setToastState] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const showToast = (message, severity) => {
    setToastState({
      open: true,
      message,
      severity,
    });
  };

  const hideToast = () => {
    setToastState({ ...toastState, open: false });
  };

  return (
    <ToastContext.Provider value={{ toastState, showToast, hideToast }}>
      {children}
    </ToastContext.Provider>
  );
};

export const LoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);


  return (
    <LoaderContext.Provider
      value={{ loading, setLoading }}
    >
      {children}
    </LoaderContext.Provider>
  );
};
